// @ts-strict-ignore
import React from 'react'
import { StepLabel, Stepper, Step, Button } from '@mui/material'
import { useTheme } from '@mui/material/styles'
import MoreButtonCard from 'components/MoreButtonCard'
import { useFragment, graphql } from 'react-relay'
import { ApplicationStepsButton_JobApplication$key } from '__generated__/ApplicationStepsButton_JobApplication.graphql'
import Box from 'components/Box'

export interface IApplicationStepsButtonProps {
  jobApplicationFragmentRef: ApplicationStepsButton_JobApplication$key
}

function ApplicationStepsButton(props: IApplicationStepsButtonProps) {
  const { jobApplicationFragmentRef } = props
  const theme = useTheme()

  const jobApplication = useFragment(
    graphql`
      fragment ApplicationStepsButton_JobApplication on JobApplication {
        status
        contractRequests {
          __typename
        }

        contract {
          status
        }

        latestInterview {
          __typename
        }
      }
    `,
    jobApplicationFragmentRef,
  )

  // hide this component until the contract status is at least 'job_application_draft' (or later)
  const show = !jobApplication || jobApplication.status === 'job_application_draft' || jobApplication.status === 'job_application_sent'
  if (!show) return null

  let step = 0

  if (jobApplication?.contract) {
    step = 3
  } else if (jobApplication?.contractRequests?.length > 0 || jobApplication?.latestInterview) { // TODO: clean this up?
    step = 2
  } else if (jobApplication?.status === 'job_application_sent') {
    step = 1
  }

  // TODO: implement cases where screening, interview, etc. were rejected
  return (
    <MoreButtonCard component={Button} buttonChildren="Application steps" style={{ marginRight: theme.spacing(2) }} popoverStyle={{ padding: 0 }}>
      <Box>
        <Stepper orientation="vertical">
          <Step completed={step > 0} active={false}>
            <StepLabel>
              Job Application Sent
            </StepLabel>
          </Step>

          <Step completed={step > 1} active={false}>
            <StepLabel>
              Screening Request
            </StepLabel>
          </Step>

          <Step completed={step > 2} active={false}>
            <StepLabel>
              Interview Request
            </StepLabel>
          </Step>

          <Step completed={step > 3} active={false}>
            <StepLabel>
              Job Offer
            </StepLabel>
          </Step>
        </Stepper>
      </Box>
    </MoreButtonCard>
  )
}

export default React.memo(ApplicationStepsButton)
